import { render } from "./RehviDetailView.vue?vue&type=template&id=52375070"
import script from "./RehviDetailView.vue?vue&type=script&lang=js"
export * from "./RehviDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__